<template>
  <div>
    <div style="display:grid; grid-template-columns:1fr 1fr; gap:12px; margin-bottom:16px;">
      <!-- Estado de Caja -->
      <div class="ide-ia-card" style="padding:16px;">
        <div style="font-size:11px; color:var(--text-faint); margin-bottom:8px;">Estado de caja</div>
        <div v-if="cajaActual" style="display:flex; flex-direction:column; gap:12px;">
          <div :style="{ background: cajaActual.estadoCaja === 'abierta' ? '#22c55e33' : '#ef444433', color: cajaActual.estadoCaja === 'abierta' ? '#22c55e' : '#ef4444', padding: '12px', borderRadius: '6px', fontWeight: '600' }">
            Caja {{ cajaActual.estadoCaja === 'abierta' ? 'ABIERTA' : 'CERRADA' }}
          </div>
          <div v-if="cajaActual.estadoCaja === 'abierta'" style="font-size:12px; color:var(--text-muted);">
            Abierta hace {{ horasDesdApertura }} horas
          </div>
          <button v-if="cajaActual.estadoCaja === 'abierta'" class="btn-add" @click="abrirCerrarForm" style="background:#ef4444;">
            Cerrar caja
          </button>
          <button v-else class="btn-add" @click="abrirAbrirForm">
            Abrir caja
          </button>
        </div>
        <div v-else>
          <div style="background:#ef444433; color:#ef4444; padding:12px; border-radius:6px; font-weight:600; margin-bottom:12px; text-align:center;">
            Sin caja para hoy
          </div>
          <button class="btn-add" @click="abrirAbrirForm">
            Abrir caja
          </button>
        </div>
      </div>

      <!-- Resumen del Día -->
      <div class="ide-ia-card" style="padding:16px;">
        <div style="font-size:11px; color:var(--text-faint); margin-bottom:8px;">Resumen del día</div>
        <div style="display:flex; flex-direction:column; gap:8px; font-size:12px;">
          <div style="display:flex; justify-content:space-between;">
            <span>Ventas:</span><strong style="color:#22c55e;">${{ ventasHoy.toFixed(2) }}</strong>
          </div>
          <div style="display:flex; justify-content:space-between;">
            <span>Gastos:</span><strong style="color:#ef4444;">-${{ gastosHoy.toFixed(2) }}</strong>
          </div>
          <div style="border-top:1px solid var(--border); padding-top:8px; display:flex; justify-content:space-between;">
            <span>Total neto:</span><strong>${{ (ventasHoy - gastosHoy).toFixed(2) }}</strong>
          </div>
        </div>
      </div>
    </div>

    <!-- Acciones Rápidas -->
    <div style="display:flex; gap:8px; margin-bottom:16px;">
      <button class="btn-add" @click="abrirFormGasto" style="flex:1; background:#0ea5e9;">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
        Registrar gasto
      </button>
      <button class="btn-add" @click="abrirFormIngreso" style="flex:1; background:#22c55e;">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>
        Ingreso manual
      </button>
    </div>

    <!-- Transacciones del Día -->
    <div class="ide-ia-card" style="overflow-x:auto; padding:0;">
      <table style="width:100%; border-collapse:collapse; font-size:12px;">
        <thead style="background:var(--bg-alt); border-bottom:1px solid var(--border);">
          <tr>
            <th style="padding:10px 12px; text-align:left; font-weight:600;">Tipo</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Monto</th>
            <th style="padding:10px 12px; text-align:left; font-weight:600;">Descripción</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Hora</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!transacciones.length" style="border-bottom:1px solid var(--border);">
            <td colspan="4" style="padding:24px; text-align:center; color:var(--text-disabled);">Sin transacciones hoy</td>
          </tr>
          <tr v-for="t in transacciones" :key="t.id" style="border-bottom:1px solid var(--border-card);">
            <td style="padding:10px 12px;">
              <span :style="{ background: tipoColor(t.tipo), color: 'white', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '600' }">
                {{ tipoLabel(t.tipo) }}
              </span>
            </td>
            <td style="padding:10px 12px; text-align:center; font-weight:600;" :style="{ color: t.tipo === 'gasto' ? '#ef4444' : '#22c55e' }">
              {{ t.tipo === 'gasto' ? '-' : '+' }}${{ Math.abs(t.monto).toFixed(2) }}
            </td>
            <td style="padding:10px 12px; color:var(--text-muted);">{{ t.descripcion || '—' }}</td>
            <td style="padding:10px 12px; text-align:center; font-size:11px; color:var(--text-faint);">{{ formatHora(t.fecha) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal: Abrir Caja -->
    <div v-if="dialogAbrirCaja" class="cat-overlay" @click.self="dialogAbrirCaja = false">
      <div class="cat-modal" style="max-width:350px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">Abrir caja</span>
          <button @click="dialogAbrirCaja = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style="padding:18px 22px;">
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Monto inicial ($)*</label>
            <input v-model.number="formAbrirCaja.montoApertura" type="number" step="0.01" class="ide-input" placeholder="Ej: 50.00" />
          </div>
        </div>
        <div style="display:flex; gap:8px; padding:16px 22px; border-top:1px solid var(--border);">
          <button @click="dialogAbrirCaja = false" style="flex:1; background:none; border:1px solid var(--border); border-radius:6px; padding:8px; cursor:pointer; color:var(--text-muted); font-family:inherit;">
            Cancelar
          </button>
          <button @click="abrirCaja" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; cursor:pointer; font-family:inherit; font-weight:600;">
            Abrir
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Cerrar Caja -->
    <div v-if="dialogCerrarCaja" class="cat-overlay" @click.self="dialogCerrarCaja = false">
      <div class="cat-modal" style="max-width:400px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">Cerrar caja - Arqueo</span>
          <button @click="dialogCerrarCaja = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style="padding:18px 22px;">
          <div style="background:var(--bg-alt); padding:12px; border-radius:6px; margin-bottom:12px; font-size:12px;">
            <div style="display:flex; justify-content:space-between; margin-bottom:4px;">
              <span>Abierto con:</span><strong>${{ cajaActual?.montoApertura.toFixed(2) }}</strong>
            </div>
            <div style="display:flex; justify-content:space-between;">
              <span>Cálculo del sistema:</span><strong>${{ (cajaActual?.montoApertura + ventasHoy - gastosHoy).toFixed(2) }}</strong>
            </div>
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Monto declarado ($)*</label>
            <input v-model.number="formCerrarCaja.montoCierreDeclarado" type="number" step="0.01" class="ide-input" placeholder="Monto contado en caja" />
          </div>
          <div v-if="diferenciaCaja !== null" :style="{ background: diferenciaCaja === 0 ? '#22c55e33' : '#ef444433', color: diferenciaCaja === 0 ? '#22c55e' : '#ef4444', padding: '10px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', textAlign: 'center' }">
            {{ diferenciaCaja === 0 ? '✓ Caja cuadra' : `Diferencia: $${Math.abs(diferenciaCaja).toFixed(2)}` }}
          </div>
        </div>
        <div style="display:flex; gap:8px; padding:16px 22px; border-top:1px solid var(--border);">
          <button @click="dialogCerrarCaja = false" style="flex:1; background:none; border:1px solid var(--border); border-radius:6px; padding:8px; cursor:pointer; color:var(--text-muted); font-family:inherit;">
            Cancelar
          </button>
          <button @click="cerrarCaja" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; cursor:pointer; font-family:inherit; font-weight:600;">
            Cerrar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Gasto/Ingreso Manual -->
    <div v-if="dialogGastoIngreso" class="cat-overlay" @click.self="dialogGastoIngreso = false">
      <div class="cat-modal" style="max-width:380px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">{{ tipoGastoIngreso === 'gasto' ? 'Registrar gasto' : 'Ingreso manual' }}</span>
          <button @click="dialogGastoIngreso = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style="padding:18px 22px;">
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Monto ($)*</label>
            <input v-model.number="formGastoIngreso.monto" type="number" step="0.01" class="ide-input" placeholder="Monto" />
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Descripción</label>
            <input v-model="formGastoIngreso.descripcion" class="ide-input" placeholder="Ej: Insumos, limpieza, etc" />
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Método de pago</label>
            <select v-model="formGastoIngreso.metodoPago" class="ide-input" style="cursor: pointer;">
              <option value="efectivo">Efectivo</option>
              <option value="transferencia">Transferencia</option>
              <option value="qr">QR</option>
              <option value="otro">Otro</option>
            </select>
          </div>
        </div>
        <div style="display:flex; gap:8px; padding:16px 22px; border-top:1px solid var(--border);">
          <button @click="dialogGastoIngreso = false" style="flex:1; background:none; border:1px solid var(--border); border-radius:6px; padding:8px; cursor:pointer; color:var(--text-muted); font-family:inherit;">
            Cancelar
          </button>
          <button @click="guardarGastoIngreso" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; cursor:pointer; font-family:inherit; font-weight:600;">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CajaSucursal',
  props: {
    sucursalId: [String, Number],
    clienteId: [String, Number],
  },
  data() {
    return {
      cajaActual: null,
      transacciones: [],
      ventasHoy: 0,
      gastosHoy: 0,
      dialogAbrirCaja: false,
      dialogCerrarCaja: false,
      dialogGastoIngreso: false,
      tipoGastoIngreso: 'gasto',
      formAbrirCaja: { montoApertura: '' },
      formCerrarCaja: { montoCierreDeclarado: '' },
      formGastoIngreso: { monto: '', descripcion: '', metodoPago: 'efectivo' },
    }
  },
  computed: {
    horasDesdApertura() {
      if (!this.cajaActual?.fechaApertura) return 0
      const ahora = new Date()
      const apertura = new Date(this.cajaActual.fechaApertura)
      return Math.floor((ahora - apertura) / 3600000)
    },
    diferenciaCaja() {
      if (!this.cajaActual || !this.formCerrarCaja.montoCierreDeclarado) return null
      const calculado = this.cajaActual.montoApertura + this.ventasHoy - this.gastosHoy
      return this.formCerrarCaja.montoCierreDeclarado - calculado
    },
  },
  watch: {
    sucursalId() {
      this.cargar()
    },
  },
  mounted() {
    this.cargar()
    this.intervalo = setInterval(() => this.cargar(), 30000)
  },
  beforeDestroy() {
    if (this.intervalo) clearInterval(this.intervalo)
  },
  methods: {
    async cargar() {
      if (!this.sucursalId) return
      try {
        const cajas = await this.$service.list(`sucursales/${this.sucursalId}/cajas`) || []
        this.cajaActual = cajas.find(c => c.estadoCaja === 'abierta') || cajas[0] || null

        this.transacciones = await this.$service.list(`sucursales/${this.sucursalId}/transacciones`) || []
        this.ventasHoy = this.transacciones
          .filter(t => t.tipo === 'venta' && t.estadoTransaccion === 'confirmado')
          .reduce((sum, t) => sum + (t.monto || 0), 0)
        this.gastosHoy = this.transacciones
          .filter(t => t.tipo === 'gasto' && t.estadoTransaccion === 'confirmado')
          .reduce((sum, t) => sum + (t.monto || 0), 0)
      } catch (err) {
        console.error(err)
      }
    },
    abrirAbrirForm() {
      this.formAbrirCaja = { montoApertura: '' }
      this.dialogAbrirCaja = true
    },
    async abrirCaja() {
      if (this.formAbrirCaja.montoApertura === '') {
        this.$message.warning('Ingresa monto inicial')
        return
      }
      try {
        await this.$service.post(`sucursales/${this.sucursalId}/caja/abrir`, {
          montoApertura: this.formAbrirCaja.montoApertura,
        })
        this.$message.success('Caja abierta')
        this.dialogAbrirCaja = false
        this.cargar()
      } catch (err) {
        this.$message.error(err.message || 'Error al abrir caja')
      }
    },
    abrirCerrarForm() {
      this.formCerrarCaja = { montoCierreDeclarado: '' }
      this.dialogCerrarCaja = true
    },
    async cerrarCaja() {
      if (this.formCerrarCaja.montoCierreDeclarado === '') {
        this.$message.warning('Ingresa monto declarado')
        return
      }
      try {
        await this.$service.post(`sucursales/${this.sucursalId}/caja/${this.cajaActual.id}/cerrar`, {
          montoCierreDeclarado: this.formCerrarCaja.montoCierreDeclarado,
        })
        this.$message.success('Caja cerrada')
        this.dialogCerrarCaja = false
        this.cargar()
      } catch (err) {
        this.$message.error(err.message || 'Error al cerrar caja')
      }
    },
    abrirFormGasto() {
      this.tipoGastoIngreso = 'gasto'
      this.formGastoIngreso = { monto: '', descripcion: '', metodoPago: 'efectivo' }
      this.dialogGastoIngreso = true
    },
    abrirFormIngreso() {
      this.tipoGastoIngreso = 'ingreso'
      this.formGastoIngreso = { monto: '', descripcion: '', metodoPago: 'efectivo' }
      this.dialogGastoIngreso = true
    },
    async guardarGastoIngreso() {
      if (!this.formGastoIngreso.monto) {
        this.$message.warning('Ingresa monto')
        return
      }
      try {
        await this.$service.post(`sucursales/${this.sucursalId}/transacciones`, {
          tipo: this.tipoGastoIngreso === 'gasto' ? 'gasto' : 'ingreso_manual',
          monto: this.formGastoIngreso.monto,
          descripcion: this.formGastoIngreso.descripcion,
          metodoPago: this.formGastoIngreso.metodoPago,
          cajaSucursalId: this.cajaActual?.id,
        })
        this.$message.success('Transacción registrada')
        this.dialogGastoIngreso = false
        this.cargar()
      } catch (err) {
        this.$message.error(err.message || 'Error al registrar')
      }
    },
    tipoColor(tipo) {
      const colores = { venta: '#22c55e', gasto: '#ef4444', ingreso_manual: '#818cf8', reembolso: '#f59e0b' }
      return colores[tipo] || '#64748b'
    },
    tipoLabel(tipo) {
      const labels = { venta: 'Venta', gasto: 'Gasto', ingreso_manual: 'Ingreso', reembolso: 'Reembolso' }
      return labels[tipo] || tipo
    },
    formatHora(fecha) {
      return new Date(fecha).toLocaleTimeString('es-BO', { hour: '2-digit', minute: '2-digit' })
    },
  },
}
</script>
